export const componentResultCode = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  NA: 'NA'
};